import styled from 'styled-components'

export const CardContainer = styled.div`
  align-self: stretch;
  min-width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  box-shadow: var(--shadow-box);
  box-sizing: border-box !important;
  overflow: hidden;
`

export const ProfileImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 140px;
  margin-left: 9px;
`

export const UserName = styled.span`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  text-transform: capitalize;
`

export const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  & > *:last-child {
    margin-right: 8px;
  }
`
